import type {
  BdExportAsFileDataRow,
} from '@bindoc-projects/util-domain-lib';
import {
  BdExportAsFileData
} from '@bindoc-projects/util-domain-lib';

export class KostDataImportProcessorResultErrorExport extends BdExportAsFileData {
  constructor(private _errors: string[]) {
    super();
  }

  override getExport(): Promise<{
    data: BdExportAsFileDataRow[];
    fields: string[];
  }> {
    return Promise.resolve({
      data: this._getData(),
      fields: this._getFields(),
    });
  }

  private _getData(): BdExportAsFileDataRow[] {
    return this._errors.map((it) => {
      return [
        {
          value: it,
          type: 'string',
        },
      ];
    });
  }

  private _getFields(): string[] {
    return ['ErrorMessage'];
  }
}
